// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home-menu-item {
  position: relative;
  padding: 12px 0;
  background: transparent;
  transition: all 0.2s ease-in-out;
  transition-property: background, border-color;
  transition: background 0.2s ease-in-out;
}

.home-menu-item .menu-item__btn-pin {
  visibility: hidden;
  position: relative;
  align-self: flex-start;
  z-index: 1;
}

.home-menu-item .menu-item__title {
  flex: 0 1 auto;
}

.home-menu-item .menu-item__btn-pin_pinned,
.home-menu-item:hover .menu-item__btn-pin {
  visibility: visible;
}
`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
